import fryingpanKv from './fryingpan/kv'
import fryingpanTechnology from './fryingpan/technology'
import topAnimation from "./fryingpan/topAnimation";
import topRecipessAnimation from "./fryingpan/topRecipessAnimation";

export default class fryingpanManager {
  constructor(param, scroll) {
    this.param = param;
    this.scroll = scroll;

    this.fryingpanKv = new fryingpanKv(param)
    this.fryingpanTechnology = new fryingpanTechnology(param, scroll, true)
    this.topAnimation = new topAnimation(param, scroll)
    this.topRecipessAnimation = new topRecipessAnimation(param, scroll)

    this.renderCount = 0

    this.isReady = true
  }
  init() {
    this.fryingpanKv.init()
    this.fryingpanTechnology.init()
    setTimeout(() => {
      this.topAnimation.init()
      this.topRecipessAnimation.init()
    }, 100)
  }
  onScroll(_y) {
    if(this.renderCount % 2 !== 0) return

    this.topAnimation.onScroll(_y)
    this.fryingpanTechnology.onScroll(_y)
  }
  render() {
    if(this.renderCount++ % 2 !== 0) return

    const { nowInc, diffInc, sighedDiffInc } = this.scroll
    this.topRecipessAnimation.render(nowInc, diffInc, sighedDiffInc)
    this.fryingpanTechnology.render()
  }

  resize(_w, _h, _display) {
    this.fryingpanKv.resize(_w, _h, _display)
    this.fryingpanTechnology.resize(_w, _h, _display)
  }
}
